const certificate = [
  {
    id: 1,
    img: "img/certificate/python.PNG",
  },
  {
    id: 2,
    img: "img/certificate/html.PNG",
  },
  {
    id: 3,
    img: "img/certificate/css.PNG",
  },
  {
    id: 4,
    img: "img/certificate/js.PNG",
  },
  {
    id: 5,
    img: "img/certificate/jquery.PNG",
  },
  {
    id: 6,
    img: "img/certificate/asyncJS.PNG",
  },
];

export default certificate;
